import React from "react";
import BugReportIcon from "@mui/icons-material/BugReport";
import {observer} from "mobx-react-lite";
import {Box, Button} from "@mui/material";
import {useStores} from "../../stores";
import type {BaseMuixTableController} from "./controllers/BaseMuixTableController.tsx";
import type {BaseMuixFilterController} from "./controllers/BaseMuixFilterController.ts";
import {environment} from "../../env.ts";
import {CONTENT_COLLAPSED_WIDTH, CONTENT_EXPANDED_WIDTH} from "../main/drawer/DrawerConstants.ts";

type Props = {
    tableController: BaseMuixTableController,
    filterController: BaseMuixFilterController,
};
export const MuixDebugComponent: React.FC<Props> = observer((
    {tableController, filterController}
) => {
    const {authStore, rootAppStore} = useStores();
    const filterModel = filterController.gridFilterModel;
    const rowIds = tableController.gridApi?.getAllRowIds() ?? [];

    if (!(environment.isTest && authStore.isMithraStaff)) {
        return <></>;
    }

    return <Box sx={{
        width: rootAppStore.isDrawerOpen ? CONTENT_EXPANDED_WIDTH : CONTENT_COLLAPSED_WIDTH,
        overflowX: 'scroll'
    }}>
        <div>
            <b>cols</b>: {JSON.stringify(tableController.tableColumns.map(c => c.field))}
        </div>
        <div>
            <b>rowIds</b>: {JSON.stringify(rowIds)}
        </div>
        <div>
            <b>rowGroupingModel</b>: {JSON.stringify(tableController.rowGroupingModel)}<br/>
        </div>
        <div>
            <b>visibilityModel</b>: {JSON.stringify(tableController.visibilityModel)}
        </div>
        <div>
            <b>pinnedColumns</b>: {JSON.stringify(tableController.pinnedColumns)}
        </div>
        <div>
            <b>gridFilterModel</b> items[{filterModel.items.length}]:
            {' ' + filterModel.items.map(i => `${i.field} ${i.operator} ${JSON.stringify(i.value)} (${i.id})`).join(' | ')}
            <br/>
            {/*{JSON.stringify(filterModel)}*/}
        </div>
        <div>
            <b>API gridFilterModel</b> items[{filterController.apiGridFilterModel.items.length}]:
            {' ' + filterController.apiGridFilterModel.items.map(i => `${i.field} ${i.operator} ${JSON.stringify(i.value)} (${i.id})`).join(' | ')}
            <br/>
            {/*{JSON.stringify(filterController.apiGridFilterModel)}*/}
        </div>
        <div>
            <b>_muiXGridFilterModel</b> items[{filterController._muiXGridFilterModel.items.length}]:
            {' ' + filterController._muiXGridFilterModel.items.map(i => `${i.field} ${i.operator} ${JSON.stringify(i.value)} (${i.id})`).join(' | ')}
        </div>
        <div>
            <b>expandedRowIds</b> items[{tableController.expandedRowIds.size}]:
            {' ' + Array.from(tableController.expandedRowIds).map(i => JSON.stringify(i)).join(' | ')}
        </div>
        <Button
            startIcon={<BugReportIcon/>}
            onClick={() => {
                tableController.devopsClearTableColumnSettings();
                window.location.reload();
            }}
        >
            clear settings
        </Button>
    </Box>
})